import { useRef } from "react";
import ReviewerService from "../../services/reviewer.service";
import CardModal from "../../components/CardModal";

const AmountForm = ({ show, onHide, projectData }) => {
	const partialAmount = useRef();
	const fullAmount = useRef();

	const handleSubmit = (e) => {
		e.preventDefault();
		const _data = {
			partialAmount: partialAmount.current.value,
			fullAmount: fullAmount.current.value,
		};
		ReviewerService.updateProjectAmount(projectData._id, _data);
	};

	return (
		<CardModal
			heading={"Review Project Amount"}
			show={show}
			onHide={onHide}
			submit={handleSubmit}
		>
			<div className="card card__project-amount" style={{ margin: "auto" }}>
				<label
					htmlFor="partial-amount-provision partial"
					className="partial-payment"
				>
					PARTIAL PAYMENT PROVISION:
				</label>
				<div className="input-holder"style={{ marginBottom: "20px" }}>
					<span>&#x20A6;</span>{" "}
					<input
						type="number"
						id="partial-amount-provision"
						name="partial-amount-provision"
						defaultValue={projectData.partialAmount}
						ref={partialAmount}
					/>
				</div>

				<label htmlFor="full-amount-provision" className="full-payment">
					FULL PAYMENT PROVISION:
				</label>
				<div className="input-holder">
					<span>&#x20A6;</span>{" "}
					<input
						type="number"
						id="full-amount-provision"
						name="full-amount-provision"
						defaultValue={projectData.fullAmount}
						ref={fullAmount}
					/>
				</div>
			</div>
		</CardModal>
	);
};

export default AmountForm;
